document.addEventListener("turbo:before-cache", function() {
  $('.slick-initialized').slick('unslick');
});
